export const SET_TABLE_PAGE = "SET_TABLE_PAGE";
export const SET_SELECTED_TICKET_CASE_ID = "SET_SELECTED_TICKET_CASE_ID";
